import { createTheme } from "@mui/material";

const theme = createTheme({
    palette: {
        primary: {
            main: "#fca311"
        },
        secondary: {
            main: "#f3ffcc"
        },
        background: {
            default:"#F5F7FA"
        },
        menuIcon: {
            main: "#ffffff"
        },
        appBarBg: {
            main: "#393939"
        },
        mainColor: {
            main: "#fca311"
        },
        logoTextColor: {
            main: "#E5E5E5"
        },
        profileMenu: {
            background: "#ffffff",
            text: "#333333",
            hover: "#f5f5f5",
            border: "#e0e0e0",
            avatar: {
                border: "#fca311"
            }
        }
    },
    typography: {
        button: {
          textTransform: 'none'
        },
        fontFamily: [
            // '-apple-system',
            // 'BlinkMacSystemFont',
            // '"Segoe UI"',
            "Recursive",
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
          ].join(','),
        }    ,
    components: {
        MuiButton: {
            defaultProps: {
                variant: "outlined",
                disableElevation: true,
            },
            styleOverrides: {
                root: {
                    borderRadius: "20px"
                }
            }
        },
        MuiTextField: {
            defaultProps: {
                variant:"outlined"
            }
        }
    }
});

export default theme;